import { Box, Container, Grid, Typography } from '@material-ui/core';
import { useMediaUp } from 'hooks';
import React, { FC } from 'react';
import { PostCard } from 'components/structures/general';
import { Post } from 'services/blog/types';
import { useRouter } from 'next/router';
import { LinkButton } from 'components/atoms';
import { POSTS_PAGE_SIZE } from 'config/cms/endpoints';

interface PostsListProps {
  posts: Post[];
  total: number;
}

const PostsList: FC<PostsListProps> = (props) => {
  const { posts, total } = props;
  const router = useRouter();
  const { page = 1 } = router.query;
  const isSmallUp = useMediaUp('sm');
  const isLargeUp = useMediaUp('lg');
  let middle = posts.slice(1);
  const end = middle.length % 3 ? posts.slice(-middle.length % 3) : [];
  middle = middle.slice(0, middle.length - end.length);

  const nextPage = Number(page) + 1;
  const scrollId = `postCard${Number(page) * POSTS_PAGE_SIZE}`;

  if (!posts.length) {
    return (
      <Container maxWidth={false} fixed>
        <Typography variant={isSmallUp ? 'h3' : 'h2'} align="center">
          No Posts Yet
        </Typography>
      </Container>
    );
  }

  return (
    <Container maxWidth={false} fixed>
      <PostCard post={posts[0]} md={7} md2={5} firstCard index={0} />

      <Grid container spacing={isSmallUp ? 6 : 8}>
        {middle.map((post, i) => (
          <Grid item sm={12} md={4} lg={4} key={i}>
            <PostCard post={post} md="auto" md2="auto" index={i + 1} />
          </Grid>
        ))}
      </Grid>

      {!!end.length &&
        (end.length === 1 ? (
          <PostCard post={end[0]} md={7} md2={5} firstCard index={posts.length - 1} />
        ) : (
          <Grid container spacing={isSmallUp ? 6 : 8}>
            <Grid item sm={12} md={6} lg={8}>
              <PostCard post={end[0]} md="auto" md2="auto" index={posts.length - 2} truncateCount={isLargeUp ? 516 : 200} />
            </Grid>
            <Grid item sm={12} md={6} lg={4}>
              <PostCard post={end[1]} md="auto" md2="auto" index={posts.length - 1} />
            </Grid>
          </Grid>
        ))}

      {posts.length < total && (
        <Grid container justifyContent="center">
          <Grid item>
            <Box mt={isSmallUp ? 8 : 6} />
            <LinkButton variant="contained" color="primary" href={`/blog?page=${nextPage}#${scrollId}`}>
              View More
            </LinkButton>
          </Grid>
        </Grid>
      )}
    </Container>
  );
};

export default PostsList;
